import { API } from 'aws-amplify'

export default async errorObject => {
  return API.post('utils', 'log-client-error', { body: errorObject })
}
